import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const CONSENT_KEY = "myapp_consent_v1";

type ConsentProps = {
  children: React.ReactNode;
};

type ConsentStatus = "accepted" | "declined" | null;

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&display=swap');
`;

export function Consent({ children }: ConsentProps) {
    const [consentStatus, setConsentStatus] = useState<ConsentStatus>(null);
    const location = useLocation();
    const showOverlay = location.pathname !== "/consent";
    const navigate = useNavigate();

    useEffect(() => {
        const saved = localStorage.getItem(CONSENT_KEY);
    
        if (saved === "accepted") {
            setConsentStatus("accepted");
        } else if (saved === "declined") {
            setConsentStatus("declined"); // 🔥 important
        } else {
            setConsentStatus(null);
        }
    }, [navigate]);

    const handleAccept = () => {
        localStorage.setItem(CONSENT_KEY, "accepted");
        setConsentStatus("accepted");
    };

    const handleDecline = () => {
        localStorage.setItem(CONSENT_KEY, "declined");
        setConsentStatus("declined");
    
        navigate("/consent-page"); // 👉 βάλε εδώ τη σελίδα που θέλεις
    };

    return (
        <>
            <style>{css}</style>

            {children}

            {showOverlay && consentStatus === null && (
                <div className="consent-overlay">
                    <div className="consent-panel">
                        <p className="consent-label">EU GDPR · Όροι Χρήσης</p>
                        <h2 className="consent-title">Όροι Χρήσης</h2>

                        <p className="consent-text">
                            Κατά την είσοδό σας στην εφαρμογή FairLegal, σας ζητείται να αποδεχθείτε τους όρους χρήσης και την πολιτική επεξεργασίας δεδομένων. Το FairLegal αποτελεί ερευνητικό εργαλείο Τεχνητής Νοημοσύνης που αξιοποιεί Μεγάλο Γλωσσικό Μοντέλο (LLM) για τον εντοπισμό και τη μείωση μεροληψίας λόγω φύλου σε νομικά και διοικητικά κείμενα. Με τη χρήση της εφαρμογής δηλώνετε ότι αποδέχεστε τη νόμιμη και ορθή χρήση της, συμπεριλαμβανομένης της μη εισαγωγής ευαίσθητων ή εμπιστευτικών δεδομένων χωρίς σχετική εξουσιοδότηση. Επιπλέον, αναγνωρίζετε ότι το περιεχόμενο που εισάγετε ενδέχεται να χρησιμοποιείται αποκλειστικά για λειτουργικούς και ερευνητικούς σκοπούς εντός της συνεδρίας, χωρίς αποθήκευση σε εξωτερικά συστήματα. Η εφαρμογή είναι σχεδιασμένη σύμφωνα με τις αρχές του GDPR και του AI Act, προάγοντας την υπεύθυνη και αξιόπιστη χρήση της Τεχνητής Νοημοσύνης.
                        </p>
                        <div className="consent-actions">
                            <button className="btn-decline" onClick={handleDecline}>
                                Δεν αποδέχομαι
                            </button>
                            <button className="btn-accept" onClick={handleAccept}>
                                Αποδέχομαι
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}